import { z } from 'zod';
export const REGION_VALUES = ['NAMER', 'LATAM', 'EMEA', 'APAC'];
// ISO 3166-1 alpha-2 country code → region. The region a country rolls up to
// drives the Opportunities Room filter: picking `APAC` matches opportunities
// classified as `{region, APAC}` *and* every `{country, X}` where X maps to APAC.
// Common ad-tech taxonomy: Russia/Turkey/Israel/Middle East/Africa → EMEA;
// Central Asia/Indian subcontinent/East-Southeast Asia/Oceania → APAC.
export const REGION_BY_COUNTRY = {
    // NAMER
    US: 'NAMER',
    CA: 'NAMER',
    MX: 'NAMER',
    GL: 'NAMER',
    BM: 'NAMER',
    PM: 'NAMER',
    // LATAM
    AR: 'LATAM',
    BO: 'LATAM',
    BR: 'LATAM',
    CL: 'LATAM',
    CO: 'LATAM',
    CR: 'LATAM',
    CU: 'LATAM',
    DO: 'LATAM',
    EC: 'LATAM',
    SV: 'LATAM',
    GT: 'LATAM',
    HN: 'LATAM',
    NI: 'LATAM',
    PA: 'LATAM',
    PY: 'LATAM',
    PE: 'LATAM',
    PR: 'LATAM',
    UY: 'LATAM',
    VE: 'LATAM',
    BZ: 'LATAM',
    GY: 'LATAM',
    SR: 'LATAM',
    GF: 'LATAM',
    // Caribbean
    AG: 'LATAM',
    AI: 'LATAM',
    AW: 'LATAM',
    BB: 'LATAM',
    BL: 'LATAM',
    BQ: 'LATAM',
    BS: 'LATAM',
    CW: 'LATAM',
    DM: 'LATAM',
    GD: 'LATAM',
    GP: 'LATAM',
    HT: 'LATAM',
    JM: 'LATAM',
    KN: 'LATAM',
    KY: 'LATAM',
    LC: 'LATAM',
    MF: 'LATAM',
    MQ: 'LATAM',
    MS: 'LATAM',
    SX: 'LATAM',
    TC: 'LATAM',
    TT: 'LATAM',
    VC: 'LATAM',
    VG: 'LATAM',
    VI: 'LATAM',
    // EMEA — Europe
    AD: 'EMEA',
    AL: 'EMEA',
    AT: 'EMEA',
    AX: 'EMEA',
    BA: 'EMEA',
    BE: 'EMEA',
    BG: 'EMEA',
    BY: 'EMEA',
    CH: 'EMEA',
    CY: 'EMEA',
    CZ: 'EMEA',
    DE: 'EMEA',
    DK: 'EMEA',
    EE: 'EMEA',
    ES: 'EMEA',
    FI: 'EMEA',
    FO: 'EMEA',
    FR: 'EMEA',
    GB: 'EMEA',
    GG: 'EMEA',
    GI: 'EMEA',
    GR: 'EMEA',
    HR: 'EMEA',
    HU: 'EMEA',
    IE: 'EMEA',
    IM: 'EMEA',
    IS: 'EMEA',
    IT: 'EMEA',
    JE: 'EMEA',
    LI: 'EMEA',
    LT: 'EMEA',
    LU: 'EMEA',
    LV: 'EMEA',
    MC: 'EMEA',
    MD: 'EMEA',
    ME: 'EMEA',
    MK: 'EMEA',
    MT: 'EMEA',
    NL: 'EMEA',
    NO: 'EMEA',
    PL: 'EMEA',
    PT: 'EMEA',
    RO: 'EMEA',
    RS: 'EMEA',
    RU: 'EMEA',
    SE: 'EMEA',
    SI: 'EMEA',
    SJ: 'EMEA',
    SK: 'EMEA',
    SM: 'EMEA',
    TR: 'EMEA',
    UA: 'EMEA',
    VA: 'EMEA',
    XK: 'EMEA',
    // EMEA — Middle East + Caucasus
    AE: 'EMEA',
    AM: 'EMEA',
    AZ: 'EMEA',
    BH: 'EMEA',
    EG: 'EMEA',
    GE: 'EMEA',
    IL: 'EMEA',
    IQ: 'EMEA',
    IR: 'EMEA',
    JO: 'EMEA',
    KW: 'EMEA',
    LB: 'EMEA',
    OM: 'EMEA',
    PS: 'EMEA',
    QA: 'EMEA',
    SA: 'EMEA',
    SY: 'EMEA',
    YE: 'EMEA',
    // EMEA — Africa
    AO: 'EMEA',
    BF: 'EMEA',
    BI: 'EMEA',
    BJ: 'EMEA',
    BW: 'EMEA',
    CD: 'EMEA',
    CF: 'EMEA',
    CG: 'EMEA',
    CI: 'EMEA',
    CM: 'EMEA',
    CV: 'EMEA',
    DJ: 'EMEA',
    DZ: 'EMEA',
    EH: 'EMEA',
    ER: 'EMEA',
    ET: 'EMEA',
    GA: 'EMEA',
    GH: 'EMEA',
    GM: 'EMEA',
    GN: 'EMEA',
    GQ: 'EMEA',
    GW: 'EMEA',
    KE: 'EMEA',
    KM: 'EMEA',
    LR: 'EMEA',
    LS: 'EMEA',
    LY: 'EMEA',
    MA: 'EMEA',
    MG: 'EMEA',
    ML: 'EMEA',
    MR: 'EMEA',
    MU: 'EMEA',
    MW: 'EMEA',
    MZ: 'EMEA',
    NA: 'EMEA',
    NE: 'EMEA',
    NG: 'EMEA',
    RE: 'EMEA',
    RW: 'EMEA',
    SC: 'EMEA',
    SD: 'EMEA',
    SH: 'EMEA',
    SL: 'EMEA',
    SN: 'EMEA',
    SO: 'EMEA',
    SS: 'EMEA',
    ST: 'EMEA',
    SZ: 'EMEA',
    TD: 'EMEA',
    TG: 'EMEA',
    TN: 'EMEA',
    TZ: 'EMEA',
    UG: 'EMEA',
    YT: 'EMEA',
    ZA: 'EMEA',
    ZM: 'EMEA',
    ZW: 'EMEA',
    // APAC — Asia
    AF: 'APAC',
    BD: 'APAC',
    BN: 'APAC',
    BT: 'APAC',
    CC: 'APAC',
    CN: 'APAC',
    CX: 'APAC',
    HK: 'APAC',
    ID: 'APAC',
    IN: 'APAC',
    IO: 'APAC',
    JP: 'APAC',
    KG: 'APAC',
    KH: 'APAC',
    KP: 'APAC',
    KR: 'APAC',
    KZ: 'APAC',
    LA: 'APAC',
    LK: 'APAC',
    MM: 'APAC',
    MN: 'APAC',
    MO: 'APAC',
    MV: 'APAC',
    MY: 'APAC',
    NP: 'APAC',
    PH: 'APAC',
    PK: 'APAC',
    SG: 'APAC',
    TH: 'APAC',
    TJ: 'APAC',
    TL: 'APAC',
    TM: 'APAC',
    TW: 'APAC',
    UZ: 'APAC',
    VN: 'APAC',
    // APAC — Oceania
    AS: 'APAC',
    AU: 'APAC',
    CK: 'APAC',
    FJ: 'APAC',
    FM: 'APAC',
    GU: 'APAC',
    KI: 'APAC',
    MH: 'APAC',
    MP: 'APAC',
    NC: 'APAC',
    NF: 'APAC',
    NR: 'APAC',
    NU: 'APAC',
    NZ: 'APAC',
    PF: 'APAC',
    PG: 'APAC',
    PN: 'APAC',
    PW: 'APAC',
    SB: 'APAC',
    TK: 'APAC',
    TO: 'APAC',
    TV: 'APAC',
    VU: 'APAC',
    WF: 'APAC',
    WS: 'APAC',
};
export const COUNTRY_CODES = Object.keys(REGION_BY_COUNTRY);
export const COUNTRIES_BY_REGION = REGION_VALUES.reduce((acc, region) => {
    acc[region] = COUNTRY_CODES.filter((code) => REGION_BY_COUNTRY[code] === region);
    return acc;
}, {});
const GLOBAL_RE = /^(global|worldwide|international|ww|world[\s-]?wide|all[\s-]?regions?|multi[\s-]?region)$/i;
const REGION_ALIASES = {
    // NAMER
    'north america': 'NAMER',
    'northern america': 'NAMER',
    namer: 'NAMER',
    na: 'NAMER',
    nam: 'NAMER',
    'n america': 'NAMER',
    // LATAM
    latam: 'LATAM',
    'latin america': 'LATAM',
    'south america': 'LATAM',
    'central america': 'LATAM',
    'latin & south america': 'LATAM',
    caribbean: 'LATAM',
    // EMEA — top-level
    emea: 'EMEA',
    europe: 'EMEA',
    'european union': 'EMEA',
    eu: 'EMEA',
    'middle east': 'EMEA',
    mena: 'EMEA',
    africa: 'EMEA',
    'europe, middle east, africa': 'EMEA',
    // EMEA — European sub-regions
    'western europe': 'EMEA',
    'eastern europe': 'EMEA',
    'central europe': 'EMEA',
    'northern europe': 'EMEA',
    'southern europe': 'EMEA',
    scandinavia: 'EMEA',
    scandinavian: 'EMEA',
    nordic: 'EMEA',
    nordics: 'EMEA',
    'nordic countries': 'EMEA',
    'nordic region': 'EMEA',
    baltics: 'EMEA',
    'baltic states': 'EMEA',
    benelux: 'EMEA',
    dach: 'EMEA',
    'iberian peninsula': 'EMEA',
    iberia: 'EMEA',
    balkans: 'EMEA',
    // EMEA — Middle East / Africa sub-regions
    gcc: 'EMEA',
    'gulf states': 'EMEA',
    'north africa': 'EMEA',
    'sub-saharan africa': 'EMEA',
    'sub saharan africa': 'EMEA',
    'west africa': 'EMEA',
    'east africa': 'EMEA',
    'southern africa': 'EMEA',
    'central africa': 'EMEA',
    // APAC
    apac: 'APAC',
    'asia pacific': 'APAC',
    'asia-pacific': 'APAC',
    asia: 'APAC',
    oceania: 'APAC',
    anz: 'APAC',
    'australia and new zealand': 'APAC',
    'australia & new zealand': 'APAC',
    sea: 'APAC',
    'south east asia': 'APAC',
    'southeast asia': 'APAC',
    'east asia': 'APAC',
    'south asia': 'APAC',
    'central asia': 'APAC',
    asean: 'APAC',
    'greater china': 'APAC',
    'indian subcontinent': 'APAC',
    subcontinent: 'APAC',
    'pacific islands': 'APAC',
};
const COUNTRY_ALIASES = {
    usa: 'US',
    'u.s.': 'US',
    'u.s.a.': 'US',
    'united states': 'US',
    'united states of america': 'US',
    america: 'US',
    uk: 'GB',
    'u.k.': 'GB',
    'united kingdom': 'GB',
    britain: 'GB',
    'great britain': 'GB',
    england: 'GB',
    'south korea': 'KR',
    'republic of korea': 'KR',
    'north korea': 'KP',
    'ivory coast': 'CI',
    "cote d'ivoire": 'CI',
    'czech republic': 'CZ',
    czechia: 'CZ',
    russia: 'RU',
    'russian federation': 'RU',
    vietnam: 'VN',
    'viet nam': 'VN',
    'hong kong': 'HK',
    'hong-kong': 'HK',
    taiwan: 'TW',
    uae: 'AE',
    'united arab emirates': 'AE',
    'saudi arabia': 'SA',
    'new zealand': 'NZ',
    philippines: 'PH',
    'the philippines': 'PH',
    netherlands: 'NL',
    'the netherlands': 'NL',
    holland: 'NL',
    turkey: 'TR',
    türkiye: 'TR',
    turkiye: 'TR',
};
/**
 * Map a free-text or legacy region string to the canonical {level, value} struct.
 * Used by (a) the Zod preprocess on OpportunityRegionSchema (so legacy strings
 * read from the DB still parse) and (b) the one-off backfill migration. Keep the
 * mapping tables above in sync with its decisions.
 *
 * Multi-value inputs ("North America & Europe") collapse to the common parent
 * (`Global` when the two sides are different regions), per MFINS-4900 hierarchy.
 * If any token in a multi-value input cannot be resolved, we also collapse to
 * `Global` rather than silently narrowing to the sibling that did resolve —
 * dropping "Western Europe" from "North America & Western Europe" would leave
 * NAMER, which then wrongly excludes the European half from an EMEA filter.
 */
export function normalizeLegacyRegion(input) {
    if (typeof input !== 'string')
        return { level: 'global', value: 'Global' };
    const raw = input.trim();
    if (!raw)
        return { level: 'global', value: 'Global' };
    const parts = raw
        .split(/\s*(?:&|,|\/|\+| and | or )\s*/i)
        .map((p) => p.trim())
        .filter(Boolean);
    if (parts.length === 0)
        return { level: 'global', value: 'Global' };
    const resolved = parts.map(resolveToken);
    const hasUnresolved = resolved.some((v) => v === null);
    if (parts.length === 1) {
        return resolved[0] ?? { level: 'global', value: 'Global' };
    }
    // Multi-token input with any unresolved piece: we can't honor the stated
    // scope, so widen to Global rather than keep only the piece that mapped.
    if (hasUnresolved)
        return { level: 'global', value: 'Global' };
    const regions = new Set();
    for (const v of resolved) {
        if (v.level === 'global')
            return { level: 'global', value: 'Global' };
        regions.add(v.level === 'region' ? v.value : REGION_BY_COUNTRY[v.value]);
    }
    if (regions.size === 1) {
        return { level: 'region', value: regions.values().next().value };
    }
    return { level: 'global', value: 'Global' };
}
function resolveToken(token) {
    const t = token.trim();
    if (!t)
        return null;
    const lower = t.toLowerCase();
    if (GLOBAL_RE.test(t))
        return { level: 'global', value: 'Global' };
    const upper = t.toUpperCase();
    if (upper.length === 2 && upper in REGION_BY_COUNTRY) {
        return { level: 'country', value: upper };
    }
    const aliasedCountry = COUNTRY_ALIASES[lower];
    if (aliasedCountry)
        return { level: 'country', value: aliasedCountry };
    const aliasedRegion = REGION_ALIASES[lower];
    if (aliasedRegion)
        return { level: 'region', value: aliasedRegion };
    if (REGION_VALUES.includes(upper)) {
        return { level: 'region', value: upper };
    }
    try {
        const names = new Intl.DisplayNames(['en'], { type: 'region' });
        for (const code of COUNTRY_CODES) {
            if (names.of(code)?.toLowerCase() === lower) {
                return { level: 'country', value: code };
            }
        }
    }
    catch {
        // Intl.DisplayNames unavailable; fall through
    }
    return null;
}
const OpportunityRegionObject = z.discriminatedUnion('level', [
    z.object({ level: z.literal('global'), value: z.literal('Global') }),
    z.object({ level: z.literal('region'), value: z.enum(REGION_VALUES) }),
    z.object({ level: z.literal('country'), value: z.enum(COUNTRY_CODES) }),
]);
export const OpportunityRegionSchema = z
    .preprocess((val) => {
    if (typeof val === 'string')
        return normalizeLegacyRegion(val);
    return val;
}, OpportunityRegionObject)
    .describe('Geographic scope of the opportunity, picked at the most specific level that fits. ' +
    'level=global → value="Global" (no regional center of gravity); ' +
    'level=region → value one of NAMER, LATAM, EMEA, APAC; ' +
    'level=country → value is an ISO 3166-1 alpha-2 code (e.g. US, JP, DE).');
